/* PawProof native product template: gallery, video carousel, variant-to-media sync, anchors. */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function pauseVideos(container, except) {
    container.querySelectorAll('video').forEach(function (video) {
      if (except && except.contains(video)) return;
      if (!video.paused) video.pause();
    });
  }

  /* Product gallery (main slider + thumbnail strip) */
  function initGallery(gallery) {
    if (gallery.dataset.ppInit === 'true') return;
    gallery.dataset.ppInit = 'true';

    var track = gallery.querySelector('[data-pp-main-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pp-slide]'));
    var thumbTrack = gallery.querySelector('[data-pp-thumb-track]');
    var thumbs = thumbTrack ? Array.prototype.slice.call(thumbTrack.querySelectorAll('[data-pp-thumb]')) : [];
    var current = parseInt(gallery.dataset.initialIndex || '0', 10) || 0;

    function indexOfMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) return i;
      }
      return -1;
    }

    function setActive(index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (thumbs[index] && thumbTrack) {
        var left = thumbs[index].offsetLeft;
        var right = left + thumbs[index].offsetWidth;
        if (left < thumbTrack.scrollLeft || right > thumbTrack.scrollLeft + thumbTrack.clientWidth) {
          thumbTrack.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
      pauseVideos(track, slides[index]);
    }

    function goTo(index, instant) {
      if (index < 0 || index >= slides.length) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(index);
    }

    gallery.querySelectorAll('[data-pp-main-prev]').forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(Math.max(0, current - 1));
      });
    });

    gallery.querySelectorAll('[data-pp-main-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(Math.min(slides.length - 1, current + 1));
      });
    });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (thumbTrack) {
      gallery.querySelectorAll('[data-pp-thumb-prev]').forEach(function (button) {
        button.addEventListener('click', function () {
          thumbTrack.scrollBy({ left: -thumbTrack.clientWidth, behavior: 'smooth' });
        });
      });
      gallery.querySelectorAll('[data-pp-thumb-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          thumbTrack.scrollBy({ left: thumbTrack.clientWidth, behavior: 'smooth' });
        });
      });
    }

    track.addEventListener('scroll', debounce(function () {
      if (!track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== current && index >= 0 && index < slides.length) setActive(index);
    }, 80));

    gallery.ppGoToMedia = function (mediaId, instant) {
      var index = indexOfMedia(mediaId);
      if (index > -1 && index !== current) goTo(index, instant);
    };

    if (current > 0) goTo(current, true);
    else setActive(0);
  }

  /* Generic scroll-snap carousel with dots */
  function initCarousel(carousel) {
    if (carousel.dataset.ppInit === 'true') return;
    carousel.dataset.ppInit = 'true';

    var track = carousel.querySelector('[data-pp-carousel-track]');
    var dotsWrap = carousel.querySelector('[data-pp-dots]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var dots = [];
    var current = 0;

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function goTo(index) {
      if (!slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      setActive(index);
      pauseVideos(track, slides[index]);
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pawproof-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    track.addEventListener('scroll', debounce(function () {
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      if (best !== current) setActive(best);
    }, 80));

    setActive(0);
  }

  /* Variant change: show that variant's featured media */
  document.addEventListener('change', function (event) {
    var picker = event.target.closest('variant-radios, variant-selects');
    if (!picker) return;
    var section = picker.closest('[data-pawproof-main]');
    if (!section) return;

    window.setTimeout(function () {
      var gallery = section.querySelector('[data-pp-gallery]');
      if (!gallery || !gallery.ppGoToMedia) return;

      var variant = picker.currentVariant;
      var mediaId = variant && variant.featured_media ? variant.featured_media.id : null;

      if (!mediaId) {
        var input = section.querySelector('form input[name="id"]');
        var map = {};
        try {
          map = gallery.dataset.variantMedia ? JSON.parse(gallery.dataset.variantMedia) : {};
        } catch (error) {
          map = {};
        }
        if (input) mediaId = map[input.value];
      }

      if (mediaId) gallery.ppGoToMedia(mediaId);
    }, 0);
  });

  /* Smooth-scroll "Shop Now" anchors */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-pp-scroll]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;
    var target = document.querySelector(hash);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Optional: go to /cart after a successful add (matches the old GemPages behaviour) */
  function initCartRedirect() {
    if (window.__pawproofCartRedirect) return;
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
    var sections = document.querySelectorAll('[data-pawproof-main][data-redirect-to-cart="true"]');
    if (!sections.length) return;
    window.__pawproofCartRedirect = true;

    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (detail) {
      if (!detail || detail.source !== 'product-form') return;
      var matches = false;
      sections.forEach(function (section) {
        var input = section.querySelector('form input[name="id"]');
        if (input && String(input.value) === String(detail.productVariantId)) matches = true;
      });
      if (!matches) return;
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      window.location.href = cartUrl;
    });
  }

  function initAll(root) {
    root.querySelectorAll('[data-pp-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-pp-carousel]').forEach(initCarousel);
    initCartRedirect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
